// import React, { useEffect, useState } from "react";
// import ApiClient from '../../api/client';

// const ClientTable = () => {
//   const [clients, setClients] = useState([]);
//   const [error, setError] = useState("");

//   const clientApi = new ApiClient();

//   useEffect(() => {
//     const fetchClients = async () => {
//       const { data, error } = await clientApi.getAllClients();
//       if (data) {
//         setClients(data);
//       } else {
//         setError(error || "Failed to fetch clients");
//       }
//     };
//     fetchClients();
//   }, []);

//   return (
//     <div className="p-4">
//       <div className="pt-32">
//         <h2 className="text-2xl font-bold mb-4">Clients</h2>
//         {error && <p className="text-red-500">{error}</p>}
//         <table className="min-w-full bg-white border">
//           <thead>
//             <tr className="bg-gray-100">
//               <th className="border px-4 py-2 text-left">ClientID</th>
//               <th className="border px-4 py-2 text-left"></th>
//               <th className="border px-4 py-2 text-left">Name</th>
//               <th className="border px-4 py-2 text-left">Email</th>
//               <th className="border px-4 py-2 text-left">Program</th>
//               <th className="border px-4 py-2 text-left">Status</th>

//             </tr>
//           </thead>
//           <tbody>
//             {clients.map((client) => (
//               <tr key={client.id}>
//                 <td className="border px-4 py-2">{client.client_code}</td>
//                 <td className="border px-4 py-2">
//                   <img
//                     src={client.image}
//                     alt={client.client_name}
//                     className="w-16 h-16 rounded-full object-cover"
//                   />
//                 </td>
//                 <td className="border px-4 py-2">{client.client_name}</td>
//                 <td className="border px-4 py-2">{client.email}</td>
//                 <td className="border px-4 py-2">{client.program}</td>
//                 <td className="border px-4 py-2 capitalize">{client.status}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default ClientTable;

// import { useState, useEffect} from "react";
// // import { useNavigate } from "react-router-dom";
// import ApiClient from '../../api/client';
// import { Link } from "react-router-dom";

// const ClientTable = () => {
//   // const navigate = useNavigate()

//   // const toHome = () => {
//   //   navigate('/')
//   // }

//   const apiClient = new ApiClient()

//   const [client, setClient] = useState([])
//   const [error, setError] = useState("")
//   const [searchQuery, setSearchQuery] = useState("")
//   const [filteredQuery, setfilteredQuery] = useState([])
//   // Client data for mapping over table rows

//   useEffect(()=>{
//     const fetchData = async() => {
//       const { data, error } = await apiClient.getAllClients()
//       if(data){
//         setClient(data)
//         setfilteredQuery(data)
//       }else{
//         setError(error || 'Failed to fetch clients!')
//       }
//     }
//     fetchData()
//   }, [])

//   const handleSearch = (e) => {
//     const query = e.target.value.toLowerCase()
//     setSearchQuery(query)

//     const filtered = client.filter((clients) =>
//       clients?.client_name?.toLowerCase().includes(query) ||
//       clients?.email?.toLowerCase().includes(query) ||
//       clients?.id?.toString().includes(query)
//     )
//     setfilteredQuery(filtered)
//   }

//   // // Navigation menu items
//   // const navigationItems = [
//   //   {
//   //     icon: "https://c.animaapp.com/etPela4A/img/home-3-1@2x.png",
//   //     label: "Home",
//   //     isActive: false,
//   //   },
//   //   {
//   //     icon: "https://c.animaapp.com/etPela4A/img/automated-logistics-1@2x.png",
//   //     label: "Programs",
//   //     isActive: false,
//   //   },
//   //   {
//   //     icon: "https://c.animaapp.com/etPela4A/img/file-shared-1@2x.png",
//   //     label: "Clients",
//   //     isActive: true,
//   //   },
//   //   {
//   //     icon: "https://c.animaapp.com/etPela4A/img/present-1@2x.png",
//   //     label: "Contacts",
//   //     isActive: false,
//   //   },
//   //   {
//   //     icon: "https://c.animaapp.com/etPela4A/img/savings-1@2x.png",
//   //     label: "Documents",
//   //     isActive: false,
//   //   },
//   // ];

//   return (
//     <div
//       className="bg-neutral-100 flex flex-row justify-center w-full"
//       data-model-id="2239:532"
//     >
//       <div className="bg-neutral-100 overflow-hidden w-full h-full">
//         <div className="relative  h-[1035px]">
//           {/* Background sections */}
//           <div className="absolute w-full h-[1035px] top-0 left-0">
//             <div className="absolute w-full h-[124px] top-0 left-0 bg-white" />
//             <div className="absolute w-full h-[911px] top-[124px] left-0 bg-white" />
//             <div className="absolute w-full h-[437px] top-[203px] left-[292px] bg-white" />
//             <div className="absolute w-full h-[336px] top-[662px] left-[292px] bg-white" />
//             <div className="absolute w-full h-[546px] top-[203px] left-[1117px] bg-white" />
//             <div className="absolute w-full h-[232px] top-[766px] left-[1117px] bg-white" />
//           </div>

//           {/* Search bar */}
//           <div className="w-[515px] top-[50px] left-[292px] absolute h-[52px] bg-neutral-100 rounded-lg" />

//           {/* Search icon and text */}
//           <div className="absolute w-[33px] h-[33px] top-[60px] left-[303px]">
//             <div className="relative w-7 h-7 top-[3px] left-[3px]">
//               <div className="relative w-[30px] h-[30px] -top-px -left-px">
//                 {/* <img
//                   className="absolute w-[11px] h-[11px] top-[19px] left-[19px]"
//                   alt="Search"
//                   src="https://c.animaapp.com/etPela4A/img/vector@2x.png"
//                 /> */}
//                 <input type="text" className="w-[490px] h-[30px] px-4 bg-neutral-100 rounded-lg" value={searchQuery} onChange={handleSearch} placeholder="Search for client" />
//               </div>
//             </div>
//           </div>

//           {/* Sidebar navigation background */}
//           <div className="w-[245px] top-[123px] left-2.5 absolute h-[52px] bg-neutral-100 rounded-lg" />

//           {/* Logo */}
//           <img
//             className="absolute w-[76px] h-[76px] top-[30px] left-14 object-cover"
//             alt="Optiva Logo"
//             src="https://c.animaapp.com/etPela4A/img/optivalogo-1@2x.png"
//           />

//           {/* Dashboard title */}
//           <div className="absolute h-[13px] top-[154px] left-[315px] [font-family:'Lato',Helvetica] font-bold text-black text-[32px] tracking-[0] leading-[13px] whitespace-nowrap">
//             Dashboard
//           </div>

//           {/* Create button */}
//           <div className="absolute w-[100px] h-9 top-[236px] left-[329px] bg-[url(https://c.animaapp.com/etPela4A/img/button.png)] bg-[100%_100%]">
//             <div className="w-[79px] left-4 relative h-[33px]">
//               <div className="absolute w-[55px] h-[33px] top-0 left-[22px] [font-family:'Lato',Helvetica] font-extrabold text-white text-base tracking-[0] leading-[13px]">
//                 Create
//               </div>
//               {/* <img
//                 className="w-[23px] h-5 absolute top-[9px] left-[-5px]"
//                 alt="Plus icon"
//                 src="https://c.animaapp.com/etPela4A/img/-@2x.png"
//               /> */}
//             </div>
//           </div>
//           {error && <p className="text-red ">{error}</p>}
//           {/* Table background image */}
//           <img
//             className="absolute w-full h-[802px] top-[200px] left-[291px]"
//             alt="Table background"
//             src="https://c.animaapp.com/etPela4A/img/th.png"
//           />

//           {/* Add New Client button */}
//           <Link to="/add" className="flex text-white w-[200px] justify-center items-center h-9 items-start gap-2.5 px-3.5 py-0 absolute top-56 left-[319px] bg-[#3d6be0] rounded-[5px]">
//             <span className="rounded-full flex justify-center w-8 bg-gray-200 text"><span className="text-gray-600 font-extrabold">+</span></span><p className="">Add New Client</p>
//           </Link>

//           {/* User profile section */}
//           <div className="absolute w-[287px] h-11 top-[50px] left-[1079px]">
//             <img
//               className="absolute w-[219px] h-[42px] top-0.5 left-0"
//               alt="User profile group"
//               src="https://c.animaapp.com/etPela4A/img/group-17@2x.png"
//             />
//             <div className="absolute w-[26px] h-[26px] top-0 left-[261px]">
//               <img
//                 className="absolute w-[27px] h-[26px] top-0 left-0"
//                 alt="Profile menu"
//                 src="https://c.animaapp.com/etPela4A/img/subtract@2x.png"
//               />
//             </div>
//           </div>

//           {/* Client table */}
//           <div className="absolute w-full h-[468px] top-[298px] left-[325px]">
//             {/* Table headers */}
//             <div className="absolute w-full h-4 top-0 left-[18px]">
//               <div className="top-0 left-0 text-[#010101] absolute [font-family:'Montserrat',Helvetica] font-semibold text-xs tracking-[0] leading-[normal]">
//                 Client_ID
//               </div>
//               <div className="top-px left-[276px] text-black absolute [font-family:'Montserrat',Helvetica] font-semibold text-xs tracking-[0] leading-[normal]">
//                 Name
//               </div>
//               <div className="top-0 left-[464px] text-black absolute [font-family:'Montserrat',Helvetica] font-semibold text-xs tracking-[0] leading-[normal]">
//                 Email
//               </div>
//               <div className="top-0 left-[727px] text-black absolute [font-family:'Montserrat',Helvetica] font-semibold text-xs tracking-[0] leading-[normal]">
//                 Program
//               </div>
//               <div className="absolute top-0 left-[853px] [font-family:'Montserrat',Helvetica] font-semibold text-black text-xs tracking-[0] leading-[normal]">
//                 Date Created
//               </div>
//             </div>

//             {/* Client rows */}
//             {filteredQuery.map((client, index) => (
//               <div
//                 key={client.id}
//                 className={`absolute w-full h-[85px] ${
//                   index === 0
//                     ? "top-[42px]"
//                     : index === 1
//                       ? "top-[146px]"
//                       : index === 2
//                         ? "top-[250px]"
//                         : "top-[355px]"
//                 } left-0`}
//               >
//                 <div className="relative w-full h-[85px] bg-white rounded-lg">
//                   <img
//                     className="absolute w-[63px] h-[55px] top-3.5 left-[131px]"
//                     alt={`${client.client_name} profile`}
//                     src={client.image}
//                   />

//                   <div className="absolute w-[108px] top-[34px] left-[17px] [font-family:'Montserrat',Helvetica] font-normal text-black text-sm tracking-[0] leading-[normal]">
//                     {client.id}
//                   </div>

//                   <div className="absolute w-[169px] top-[35px] left-[295px] [font-family:'Montserrat',Helvetica] font-normal text-black text-sm tracking-[0] leading-[normal]">
//                     {client.client_name}
//                   </div>

//                   <div className="absolute w-[121px] top-[34px] left-[481px] [font-family:'Montserrat',Helvetica] font-normal text-black text-sm tracking-[0] leading-[normal]">
//                     {client.email}
//                   </div>

//                   <div className="absolute w-[249px] h-[17px] top-[34px] left-[744px]">
//                     <div className="w-[263px] top-0 left-0 [font-family:'Montserrat',Helvetica] text-sm leading-[normal] absolute font-normal text-black tracking-[0]">
//                       {client.program}
//                     </div>
//                     {/* <div className="absolute w-[124px] top-0 left-[125px] [font-family:'Montserrat',Helvetica] font-normal text-black text-sm tracking-[0] leading-[normal]">
//                       {client.created}
//                     </div> */}
//                   </div>

//                   {/* Progress bar */}
//                   <div className="absolute w-[90px] h-[13px] top-[35px] left-[873px]">
//                     <div className="relative h-3.5 -top-px">
//                       <div className="absolute w-[90px] h-3 top-0.5 left-0 bg-[#d9d9d9]" />
//                       <div
//                         className="absolute h-3 top-0.5 left-0 bg-[#f4e79d]"
//                         style={{ width: `${(client.progress / 100) * 90}px` }}
//                       />
//                       <div className="absolute top-0 left-[60px] [font-family:'Lato',Helvetica] font-extrabold text-black text-[11px] tracking-[0] leading-[normal] whitespace-nowrap">
//                         {client.progress}%
//                       </div>
//                     </div>
//                   </div>

//                   {/* Action buttons */}
//                   <div className="absolute w-[15px] h-[18px] top-[33px] left-[1034px] rotate-180">
//                     <img
//                       className="absolute w-[15px] h-[18px] top-0 left-0 -rotate-180"
//                       alt="More options"
//                       src="https://c.animaapp.com/etPela4A/img/vector-20@2x.png"
//                     />
//                   </div>

//                   <div className="absolute w-[18px] h-[19px] top-[33px] left-[984px] bg-[url(https://c.animaapp.com/etPela4A/img/vector-21@2x.png)] bg-[100%_100%]" />
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ClientTable

// import { useState, useEffect} from "react"
// // import { useNavigate } from "react-router-dom";
// import ApiClient from '../../api/client'
// import Logo from '../../../assets/logo.png'
// import { toast } from 'react-toastify'
// import SideBar from "./SideBar"
// // import { Link } from "react-router-dom";

// import {
//   Home,
//   Users,
//   FileText,
//   Plus,
//   Search,
//   Edit,
//   Trash2
// } from 'lucide-react'
// import { useNavigate } from "react-router-dom";

// const ClientTable = () => {
//   const [isCollapsed, setIsCollapsed] = useState(false)
//   const [isMobile, setIsMobile] = useState(false)
//   const [activeMenu, setActiveMenu] = useState('Home')
//   const [clients, setClients] = useState([])
//   const [profilePic, setProfilePic] = useState("")
//   // const [image, setImage] = useState(false)
//   const [error, setError] = useState('')
//   const [searchQuery, setSearchQuery] = useState('')
//   const [filteredClients, setFilteredClients] = useState([])

//   const apiClient = new ApiClient()

//   // Check if screen is medium or smaller
//   useEffect(() => {
//     const checkScreenSize = () => {
//       setIsMobile(window.innerWidth < 768)
//       if (window.innerWidth < 768) {
//         setIsCollapsed(true)
//       }
//     };

//     checkScreenSize();
//     window.addEventListener('resize', checkScreenSize);
//     return () => window.removeEventListener('resize', checkScreenSize)
//   }, []);

//   // Fetch clients data
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const { data, error } = await apiClient.getAllClients()
//         if (data) {
//           setClients(data)
//           setFilteredClients(data)
//         } else {
//           setError(error || 'Failed to fetch clients!')
//         }
//       } catch (err) {
//         setError('Failed to fetch clients!')
//       }
//     };
//     fetchData()
//   }, [])

//   useEffect(()=> {

//     const fetchProfilePic = async() => {
//       try {
//         const { data, error } = await apiClient.userProfilePic()
//         if(data){
//           setProfilePic(data)
//         }else{
//           setError(error)
//         }
//       }catch(error){
//         setError(error || 'Error fetching image')
//       }
//     }
//     fetchProfilePic()
//   }, [])

//   // Handle search functionality
//   const handleSearch = (e) => {
//     const query = e.target.value.toLowerCase()
//     setSearchQuery(query)

//     const filtered = clients.filter((client) =>
//       client?.client_name?.toLowerCase().includes(query) ||
//       // client?.email?.toLowerCase().includes(query) ||
//       client?.id?.toString().includes(query) ||
//       client?.program?.toLowerCase().includes(query)
//     )
//     setFilteredClients(filtered)
//   }

//   const toggleSidebar = () => {
//     setIsCollapsed(!isCollapsed)
//   }

//   // const bottomMenuItems = [
//   //   { icon: HelpCircle, label: 'Help' },
//   //   { icon: LogOut, label: 'Logout' },
//   // ];

//   return (
//     <div className="flex h-screen bg-gray-100">

//       {/* Mobile Overlay */}
//       {isMobile && !isCollapsed && (
//         <div
//           className="fixed inset-0 z-40 md:hidden"
//           onClick={toggleSidebar}
//         />
//       )}
//         <SideBar />
//       {/* Main Content */}
//       <div className="flex-1 flex flex-col overflow-hidden">
//         {/* Header Bar */}
//         <header className="bg-white border-b border-gray-200 px-6 py-4">
//           <div className="flex items-center justify-between">
//             <div className="flex items-center">
//               {/* Mobile Menu Button */}
//               {/* {isMobile && (
//                 <button
//                   onClick={toggleSidebar}
//                   className="mr-4 p-2 rounded-lg hover:bg-gray-100 md:hidden"
//                 >
//                   <Menu className="w-5 h-5 text-gray-600" />
//                 </button>
//               )} */}
//               <h2 className="ml-8 text-xl font-semibold text-gray-800">{activeMenu}</h2>
//             </div>

//             <div className="flex items-center space-x-4 mr-8">
//               <div className="w-8 h-8 rounded-full flex items-center justify-center">
//                 {profilePic && profilePic?.image ? (
//                   <img className="rounded-full" src={profilePic?.image} alt="" />
//                 ):profilePic && profilePic?.full_name ? (
//                   <span className="text-blue-800 text-md font-bold">{profilePic?.full_name}</span>
//                 ):(
//                   <span className="text-blue-600">User</span>
//                 )}

//               </div>
//             </div>
//           </div>
//         </header>

//         {/* Main Content Area */}
//         <main className="flex-1 overflow-auto p-6 bg-[#E8ECFF]">
//           {activeMenu === 'Home' ? (
//             // Dashboard/Home Content
//             <div className="max-w-7xl mx-auto">
//               {/* Header Section */}
//               <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
//                 <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
//                   <h1 className="text-2xl font-bold text-gray-900">Dashboard</h1>

//                   <div className="flex flex-col md:flex-row gap-3">
//                     {/* Search Bar */}
//                     <div className="relative">
//                       <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
//                       <input
//                         type="text"
//                         placeholder="Search clients..."
//                         value={searchQuery}
//                         onChange={handleSearch}
//                         className="pl-10 pr-4 py-2 w-full md:w-64 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
//                       />
//                     </div>

//                     {/* Add New Client Button */}
//                     <button className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200">
//                       <Plus className="w-4 h-4" />
//                       Add New Client
//                     </button>
//                   </div>
//                 </div>
//               </div>

//               {/* Client Table */}
//               <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
//                 {error && (
//                   <div className="p-4 bg-red-50 border-l-4 border-red-400">
//                     <p className="text-red-700">{error}</p>
//                   </div>
//                 )}

//                 {/* Table Header */}
//                 <div className="px-6 py-4 border-b border-gray-200">
//                   <div className="grid grid-cols-12 gap-4 text-sm font-medium text-gray-700">
//                     <div className="col-span-1">Client_ID</div>
//                     <div className="col-span-1"></div>
//                     <div className="col-span-3">Name</div>
//                     <div className="col-span-2">Program</div>
//                     <div className="col-span-3">Email</div>
//                     <div className="col-span-1">Actions</div>
//                   </div>
//                 </div>
//                 <div className="w-auto h-4 bg-[#E8ECFF]"></div>
//                 {/* Table Body */}
//                 <div className="divide-y-[16px] divide-[#E8ECFF]">
//                   {filteredClients.length > 0 ? (
//                     filteredClients.map((client) => (
//                       <div key={client.id} className="px-6 py-4 hover:bg-gray-50 transition-colors duration-150">
//                         <div className="grid grid-cols-12 gap-4 items-center">
//                           {/* Client ID */}
//                           <div className="col-span-1">
//                             <span className="text-sm font-medium text-blue-600">{client.id}</span>
//                           </div>

//                           {/* Photo */}
//                           <div className="col-span-1 flex items-center gap-0">
//                             <div className="w-10 h-10 rounded-full flex items-center justify-center">
//                               {/* <span className="text-blue-600 text-sm font-medium">
//                                 {client.client_name.charAt(0)}
//                               </span> */}
//                               <a href="#"><img className="rounded-full pointer" src={client.image} alt="client image" /></a>
//                             </div>
//                             {/* <span className="text-sm font-medium text-gray-900">{client.client_name}</span> */}
//                           </div>

//                           {/* Name */}
//                           <div className="col-span-3 flex items-center gap-3">
//                             {/* <div className="w-10 h-10 rounded-full flex items-center justify-center">
//                                <span className="text-blue-600 text-sm font-medium">
//                                 {client.client_name.charAt(0)}
//                               </span>
//                               <img className="rounded-full" src={client.image} alt="client image" />
//                             </div> */}
//                             <span className="text-sm font-medium text-gray-900">{client.client_name}</span>
//                           </div>

//                           {/* Phone */}
//                           {/* <div className="col-span-2">
//                             <span className="text-sm text-gray-600">{client.phone}</span>
//                           </div> */}

//                           {/* Program */}
//                           <div className="col-span-2">
//                             <span className="text-sm text-gray-900">{client.program}</span>
//                           </div>

//                           {/* Date Created */}
//                           <div className="col-span-3 flex">
//                             <span className="text-sm text-gray-600">{client.email}</span>
//                           </div>

//                           {/* Actions and Progress */}
//                           <div className="col-span-1 flex items-center gap-2">
//                             {/* Progress Bar */}
//                             <div className="flex-1">
//                               <div className="w-full bg-gray-200 rounded-full h-2">
//                                 <div
//                                   className="bg-green-500 h-2 rounded-full transition-all duration-300"
//                                   style={{ width: `${client.completion}%` }}
//                                 ></div>
//                               </div>
//                               <span className="text-xs text-gray-500 mt-1">{client.completion}%</span>
//                             </div>

//                             {/* Action Buttons */}
//                             <div className="flex gap-1">
//                               <button className="p-1 text-gray-400 hover:text-blue-600 transition-colors duration-200">
//                                 <Edit className="w-4 h-4" />
//                               </button>
//                               <button className="p-1 text-gray-400 hover:text-red-600 transition-colors duration-200">
//                                 <Trash2 className="w-4 h-4" />
//                               </button>
//                             </div>
//                           </div>
//                         </div>
//                       </div>

//                     ))
//                   ) : (
//                     <div className="px-6 py-12 text-center">
//                       <Users className="w-12 h-12 text-gray-300 mx-auto mb-4" />
//                       <p className="text-gray-500">
//                         {searchQuery ? 'No clients found matching your search.' : 'No clients found.'}
//                       </p>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           ) : (
//             // Other Menu Content
//             <div className="max-w-4xl mx-auto">
//               <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
//                 <h3 className="text-lg font-medium text-gray-900 mb-4">Welcome to {activeMenu}</h3>
//                 <p className="text-gray-600 mb-4">
//                   You are currently viewing the {activeMenu} section. The sidebar automatically collapses on medium screens and below,
//                   showing only icons with helpful tooltips on hover. Click on different menu items to see them become active.
//                 </p>

//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
//                   <div className="bg-blue-50 p-4 rounded-lg">
//                     <div className="flex items-center">
//                       <Home className="w-8 h-8 text-blue-600" />
//                       <div className="ml-3">
//                         <p className="text-sm font-medium text-blue-600">Dashboard</p>
//                         <p className="text-xs text-blue-500">Main overview</p>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="bg-green-50 p-4 rounded-lg">
//                     <div className="flex items-center">
//                       <Users className="w-8 h-8 text-green-600" />
//                       <div className="ml-3">
//                         <p className="text-sm font-medium text-green-600">Clients</p>
//                         <p className="text-xs text-green-500">Manage clients</p>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="bg-purple-50 p-4 rounded-lg">
//                     <div className="flex items-center">
//                       <FileText className="w-8 h-8 text-purple-600" />
//                       <div className="ml-3">
//                         <p className="text-sm font-medium text-purple-600">Documents</p>
//                         <p className="text-xs text-purple-500">File management</p>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//         </main>
//       </div>
//     </div>
//   );
// };

// export default ClientTable;

import { useState, useEffect } from 'react'
// import { useNavigate } from "react-router-dom";
import ApiClient from '../../../api/client'
// import Logo from '../../../../assets/logo.png'
// import { toast } from 'react-toastify'
import SideBar from '../SideBar'
// import { Link } from "react-router-dom";

import { Home, Users, FileText, Plus, Edit, Trash2 } from 'lucide-react'
import { useNavigate, useParams } from 'react-router-dom'
import Navbar from '../Navbar'
import SearchBar from '../SearchBar'
import { useClientStore } from '../../../../store/useClientStore'
import { useSearchStore } from '../../../../store/useSearchStore'

import { useUIStore } from '../../../../store/useUIStore'
import DeleteModal from './DeleteModal'
import UpdateClientModal from './UpdateClientModal'
import AddNewClientModal from './AddNewClientModal'

const apiClient = new ApiClient()

const ClientTable = () => {
  const {
    deleteClient,
    showDeleteModal,
    clientToDelete,
    openDeleteModal,
    closeDeleteModal,
    openUpdateModal,
    showAddClientModal,
    openAddClientModal,
    closeAddClientModal,
    closeUpdateModal,
  } = useClientStore()

  const { client, filteredClients, searchQuery, setClients } = useSearchStore()

  const { isMobile, activeMenu } = useUIStore()
  const [error, setError] = useState('')
  const [progressBar, setProgressBar] = useState(0)
  // const [color, setColor] = useState('')
  const [summaries, setSummaries] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  // const [clientId, setClientId] = useState(null)

  // Declare the ApiClient class for use and get its individual api functions
  const navigate = useNavigate()

  // Fetch clients data
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const { data, error } = await apiClient.getAllClients()
  //       if (data) {
  //         setClients(data)
  //       } else {
  //         setError(error || 'Failed to fetch clients!')
  //       }
  //     } catch (err) {
  //       setError('Failed to fetch clients!')
  //     }
  //   }
  //   const fetchSummary = async (clientId) => {
  //     const { data, error } = await apiClient.fetchSummary(clientId)
  //     if (data) {
  //       setSummary(data)
  //     }
  //     const value = summary
  //     setProgressBar(value)

  //     if (progressBar <= 19) {
  //       setColor('red')
  //     }
  //     if (progressBar >= 20) {
  //       setColor('yellow')
  //     }
  //     if (progressBar >= 70) {
  //       setColor('green')
  //     }
  //   }

  //   fetchData()
  //   if (selectedClientId)
  //   fetchSummary()
  // }, [progressBar, showDeleteModal, showAddClientModal])
  // Fetch clients and their summaries
  useEffect(() => {
    const fetchData = async () => {
      // setIsLoading(true)
      try {
        const { data, error } = await apiClient.getAllClients()
        if (data) {
          setClients(data)
          // Fetch summaries for all clients
          await fetchAllSummaries(data)
        } else {
          setError(error || 'Failed to fetch clients!')
        }
      } catch (err) {
        setError('Failed to fetch clients!')
      } finally {
        // setIsLoading(false)
      }
    }
    const fetchAllSummaries = async (clients) => {
      const summaryPromises = clients.map(async (client) => {
        try {
          const { data, error } = await apiClient.fetchSummary(client.id)
          const percentage =
            data?.percentage_completion || data?.completion || data || 0
          return { clientId: client.id, percentage }
        } catch (error) {
          return { client: client.id, percentage: 0 }
        }
      })

      const results = await Promise.all(summaryPromises)

      // Convert array to object for easy lookup
      const summaryMap = {}
      results.forEach(({ clientId, percentage }) => {
        summaryMap[clientId] = percentage || 0
      })

      setSummaries(summaryMap)
    }

    fetchData()
  }, [showDeleteModal, showAddClientModal])

  // Helper function to get color based on progress
  const getProgressColor = (progress) => {
    if (!progress || progress <= 19) return 'bg-red-500'
    if (progress >= 70) return 'bg-green-500'
    return 'bg-yellow-400'
  }
  // Helper function to safely get summary
  const getClientSummary = (clientId) => {
    return summaries[clientId] ?? 0 // Use nullish coalescing for safety
  }

  const handleClientImageClick = (clientId) => {
    navigate(`/dashboard/client/${clientId}/family`)
  }

  // Delete a particular client
  const handleConfirmDelete = async () => {
    if (clientToDelete) {
      await deleteClient(clientToDelete.id)
      closeDeleteModal()
      // toast.success(`${clientToDelete?.client_name} has  been deleted successfully!`, {
      //   position: 'top-right',
      //   autoClose: 3000,
      //   theme: 'colored',
      // })
    }
  }
  // Show loading state
  // if (isLoading) {
  //   return (
  //     <div className="flex h-screen bg-gray-100">
  //       <SideBar />
  //       <div className="flex-1 flex flex-col overflow-hidden">
  //         <Navbar />
  //         <main className="flex-1 flex items-center justify-center">
  //           <div className="text-center">
  //             <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
  //             <p className="text-gray-600">Loading clients...</p>
  //           </div>
  //         </main>
  //       </div>
  //     </div>
  //   )
  // }
  return (
    <>
      <div className="flex h-screen bg-gray-100">
        {/* Mobile Overlay */}
        {/* {isMobile && !isCollapsed && (
          <div 
            className="fixed inset-0 z-40 md:hidden"
            // onClick={toggleSidebar}
          />
        )} */}
        <SideBar />
        {/* Main Content */}
        <div className="flex-1 flex flex-col overflow-hidden">
          {/* Header Bar */}
          <Navbar />

          {/* Main Content Area */}
          <main className="p-4 flex-1 overflow-auto p-6 bg-gray-100">
            {isMobile && (
              <div className="mb-4">
                <SearchBar />
              </div>
            )}
            <div className="max-w-[95%] mx-auto mb-4">
              <h1 className="text-2xl md:text-4xl font-bold text-gray-900">
                Client Dashboard
              </h1>
            </div>

            <div
              className={`${isMobile ? 'w-full bg-[#E8ECFF] p-8 h-full rounded-md overflow-x-auto' : 'max-w-[95%] mx-auto bg-[#E8ECFF] p-8 pb-4 rounded-md'}`}
            >
              {activeMenu === 'Clients' ? (
                // Dashboard/Home Content
                <div className="mx-auto">
                  {/* Header Section */}
                  <div className="mb-6">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                      <div className="flex flex-col md:flex-row gap-3">
                        {/* Add New Client Button */}
                        <button
                          onClick={openAddClientModal}
                          className="flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200"
                        >
                          <Plus className="w-4 h-4" />
                          <span>Add New Client</span>
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Client Table */}
                  <div className="overflow-x-auto bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                    {/* {error && (
                      <div className="p-4 bg-red-50 border-l-4 border-red-400">
                        <p className="text-red-700">{error}</p>
                      </div>
                    )} */}

                    {/* Table Header */}
                    <div className="bg-white px-6 py-4 border-b border-gray-200 min-w-[1000px]">
                      <div className="grid grid-cols-12 gap-4 text-sm font-bold text-indigo-800">
                        <div className="col-span-1">SN</div>
                        <div className="col-span-1">ClientID</div>
                        <div className="col-span-1"></div>
                        <div className="col-span-2">Name</div>
                        <div className="col-span-2">Program</div>
                        <div className="col-span-2">Email</div>
                        <div className="col-span-1">Status</div>
                        <div className="col-span-2">Actions</div>
                      </div>
                    </div>
                    <div className="w-auto h-4 bg-[#E8ECFF] min-w-[1000px]"></div>
                    {/* Table Body */}
                    <div className="divide-y-[16px] divide-[#E8ECFF] min-w-[1000px]">
                      {filteredClients.length > 0 ? (
                        filteredClients.map((client) => {
                          const clientProgress = getClientSummary(client.id)
                          return (
                            <div
                              key={client.id}
                              className="px-6 py-4 hover:bg-gray-50 transition-colors duration-150"
                            >
                              <div className="grid grid-cols-12 gap-4 items-center">
                                {/* Client ID */}
                                <div className="col-span-1">
                                  <span className="text-sm font-medium text-blue-600">
                                    {client.id}
                                  </span>
                                </div>

                                {/* Client ID */}
                                <div className="col-span-1">
                                  <span className="text-sm font-medium text-blue-600">
                                    {client.client_id}
                                  </span>
                                </div>

                                {/* Photo */}
                                <div className="col-span-1 flex items-center gap-0">
                                  <div className="w-10 h-10 rounded-full flex items-center justify-center">
                                    {/* <span className="text-blue-600 text-sm font-medium">
                                    {client.client_name.charAt(0)}
                                  </span> */}
                                    <img
                                      className="rounded-lg pointer cursor-pointer"
                                      src={client.image}
                                      alt="client image"
                                      onClick={() =>
                                        handleClientImageClick(client.id)
                                      }
                                    />
                                  </div>
                                  {/* <span className="text-sm font-medium text-gray-900">{client.client_name}</span> */}
                                </div>

                                {/* Name */}
                                <div className="col-span-2 flex items-center gap-3">
                                  {/* <div className="w-10 h-10 rounded-full flex items-center justify-center">
                                  <span className="text-blue-600 text-sm font-medium">
                                    {client.client_name.charAt(0)}
                                  </span>
                                  <img className="rounded-full" src={client.image} alt="client image" />
                                </div> */}
                                  <span className="text-sm font-medium text-gray-900">
                                    {client.client_name}
                                  </span>
                                </div>

                                {/* Phone */}
                                {/* <div className="col-span-2">
                                <span className="text-sm text-gray-600">{client.phone}</span>
                              </div> */}

                                {/* Program */}
                                <div
                                  className={`${client.program_name ? 'text-black' : 'text-red'} col-span-2`}
                                >
                                  <span className="text-sm text-gray-900">
                                    {client.program_name ||
                                      'No program assigned'}
                                  </span>
                                </div>

                                {/* Email Address */}
                                <div className="col-span-2 flex">
                                  <span className="text-sm text-gray-600">
                                    {client.email}
                                  </span>
                                </div>

                                {/* Status */}
                                <div className="col-span-1 flex">
                                  <span className="text-sm text-gray-600">
                                    {client.status}
                                  </span>
                                </div>

                                {/* Actions and Progress */}
                                <div className="col-span-2 flex items-center gap-2">
                                  {/* Progress Bar */}
                                  <div className="flex items-center justify-end">
                                    <span className="text-sm font-bolder text-black-800">
                                      {clientProgress || 0}%
                                    </span>
                                    <div className="bg-gray-200 rounded-full h-2 w-12">
                                      {/* {color == 'red' && ( */}
                                      <div
                                        className={`h-2 rounded-full transition-all duration-300 ${getProgressColor(clientProgress || 0)}`}
                                        style={{
                                          width: `${Math.min((clientProgress || 0) / 100) * 48}px`,
                                        }}
                                      ></div>
                                      {/* )} */}
                                      {/* {color == 'yellow' && (
                                      <div
                                        className="bg-yellow-200 h-2 rounded-full transition-all duration-300"
                                        style={{
                                          width: `${(progressBar / 100) * 48}px`,
                                        }}
                                      ></div>
                                    )}
                                    {color == 'green' && (
                                      <div
                                        className="bg-green-500 h-2 rounded-full transition-all duration-300"
                                        style={{
                                          width: `${(progressBar / 100) * 48}px`,
                                        }}
                                      ></div>
                                    )} */}
                                    </div>
                                  </div>

                                  {/* Action Buttons */}
                                  <div className="flex gap-1">
                                    <button className="p-1 text-gray-400 hover:text-blue-600 transition-colors duration-200">
                                      <Edit
                                        onClick={() => openUpdateModal(client)}
                                        className="w-5 h-5"
                                      />
                                    </button>
                                    <button className="p-1 text-gray-400 hover:text-red-600 transition-colors duration-200">
                                      <Trash2
                                        onClick={() => openDeleteModal(client)}
                                        className="w-5 h-5"
                                      />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        })
                      ) : (
                        <div className="px-6 py-12 text-center">
                          <Users className="w-12 h-12 text-gray-300 mx-auto mb-4" />
                          <p className="text-gray-500">
                            {searchQuery
                              ? 'No clients found matching your search.'
                              : 'No clients found.'}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                // Other Menu Content
                <div className="max-w-4xl mx-auto">
                  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    <h3 className="text-lg font-medium text-gray-900 mb-4">
                      Welcome to {activeMenu}
                    </h3>
                    <p className="text-gray-600 mb-4">
                      You are currently viewing the {activeMenu} section. The
                      sidebar automatically collapses on medium screens and
                      below, showing only icons with helpful tooltips on hover.
                      Click on different menu items to see them become active.
                    </p>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
                      <div className="bg-blue-50 p-4 rounded-lg">
                        <div className="flex items-center">
                          <Home className="w-8 h-8 text-blue-600" />
                          <div className="ml-3">
                            <p className="text-sm font-medium text-blue-600">
                              Dashboard
                            </p>
                            <p className="text-xs text-blue-500">
                              Main overview
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="bg-green-50 p-4 rounded-lg">
                        <div className="flex items-center">
                          <Users className="w-8 h-8 text-green-600" />
                          <div className="ml-3">
                            <p className="text-sm font-medium text-green-600">
                              Clients
                            </p>
                            <p className="text-xs text-green-500">
                              Manage clients
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="bg-purple-50 p-4 rounded-lg">
                        <div className="flex items-center">
                          <FileText className="w-8 h-8 text-purple-600" />
                          <div className="ml-3">
                            <p className="text-sm font-medium text-purple-600">
                              Documents
                            </p>
                            <p className="text-xs text-purple-500">
                              File management
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </main>
        </div>
      </div>

      {/* Reusable DeleteModal */}
      <DeleteModal
        isOpen={showDeleteModal}
        title="Confirm Delete"
        message={`Are you sure you want to delete "${clientToDelete?.client_name}"?`}
        onConfirm={handleConfirmDelete}
        onCancel={closeDeleteModal}
      />

      {/* Reusable UpdateClientModal */}
      <UpdateClientModal onClose={closeUpdateModal} />

      {/* Reusable AddNewClientModal */}
      <AddNewClientModal
        isOpen={showAddClientModal}
        onClose={closeAddClientModal}
      />
    </>
  )
}

export default ClientTable
